// extracted by mini-css-extract-plugin
export var container = "_na-0";
export var dotAnimation = "_na-2";
export var dotsLoading = "_na-1";